import { render, staticRenderFns } from "./ConfirmTransfer.vue?vue&type=template&id=00d81db6"
import script from "./ConfirmTransfer.vue?vue&type=script&lang=ts"
export * from "./ConfirmTransfer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports